import React from 'react'
import { Link } from 'react-router-dom'

const Error = () => {
  return (
    <section className='error-page'>
      <div className='error-container'>
        <h1>oops! this page does not exist</h1>
      </div>
    </section>
  )
}

export default Error
